import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class LegalDocumentService {

    private baseUrl: string = '../rest/company';
    constructor (
        private http: Http
    ) {}

    get(companyOid, contractOid, legalDocumentOid): any {
        return this.http.get(`${this.baseUrl}/${companyOid}/contract/${contractOid}/legalDocument/${legalDocumentOid}`)
            .map((res:any) => res.json());
    }

    getAll(companyOid, contractOid): any {
        return this.http.get(`${this.baseUrl}/${companyOid}/contract/${contractOid}/legalDocument`)
            .map((res:any) => res.json());
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/core/legal_document_service.ts